export default {
  title: 'Verpasste Bestellungen',
  card_title: 'E-Mails zu verpassten Bestellungen',
  intro:
    'Nimmt niemand eine Bestellung innerhalb von {{minutes}} Minuten an, wird sie automatisch abgelehnt. Dann bekommt jede Adresse auf dieser Liste eine E-Mail mit der Bestellung, damit sich jemand darum kümmern kann.',
  default: {
    owner: 'Restaurantinhaber',
    partner: 'Partner',
    owner_missing: 'Der Restaurantinhaber ({{email}}) bekommt diese E-Mails nicht.',
    partner_missing: 'Die Standardadresse des Partners ({{email}}) bekommt diese E-Mails nicht.',
  },
  empty:
    'Niemand würde von verpassten Bestellungen erfahren. Fügen Sie mindestens eine E-Mail-Adresse hinzu, um zu speichern.',
  save_error:
    'Die E-Mail-Adressen konnten nicht gespeichert werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  load_error:
    'Die E-Mail-Adressen konnten nicht geladen werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
  unavailable: 'E-Mails zu verpassten Bestellungen gibt es für dieses Restaurant nicht.',
  buttons: {
    save: 'Speichern',
    retry: 'Erneut versuchen',
  },
  toasts: {
    saved: 'E-Mails zu verpassten Bestellungen gespeichert',
  },
};
